import { create } from 'zustand';
import type { NegocioVista } from '@shared/types';
import { aplicarColorPrimario } from '../utils/colors';

interface NegocioState {
  negocio: NegocioVista | null;
  cargando: boolean;
  /**
   * Sprint 158 (DT-132) — La consulta FALLÓ, que no es lo mismo que "no hay negocio". Sin
   * distinguirlo, una caída de la base abría el asistente de instalación, cuyo paso 4 crea un dueño.
   */
  sinConexion: boolean;
  cargar: () => Promise<void>;
  setNegocio: (n: NegocioVista | null) => void;
}

export const useNegocioStore = create<NegocioState>((set, get) => ({
  negocio: null,
  cargando: true,
  sinConexion: false,
  cargar: async () => {
    set({ cargando: true });
    const res = await window.api.negocio.obtener();
    if (res.ok && res.data) {
      set({ negocio: res.data, cargando: false, sinConexion: false });
      aplicarColorPrimario(res.data.colorPrimario);
    } else {
      // ok con data vacía = todavía no hay negocio (instalación nueva); !ok = no se pudo preguntar.
      // Si ya se tenía el negocio (una recarga tras guardar ajustes), un fallo momentáneo no tapa
      // toda la aplicación: se conserva lo que había.
      if (!res.ok && get().negocio) {
        set({ cargando: false });
        return;
      }
      set({ negocio: null, cargando: false, sinConexion: !res.ok });
    }
  },
  setNegocio: (n) => {
    set({ negocio: n });
    if (n) aplicarColorPrimario(n.colorPrimario);
  },
}));
